// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"7979aa49","434":"07b99942","453":"7ab505ab","455":"b10c391b","626":"0acdeecd","977":"8e7e6f25"}[chunkId] + ".chunk.js";
};